module.exports = __webpack_public_path__ + "static/aamir-badruddin-b356943d5769c7bf6b59ce06eb70c96b.jpg";